module.exports = __webpack_public_path__ + "img/fw-bg.958bd702.png";